import { IonItem, IonLabel, IonAvatar, IonText, IonImg } from '@ionic/react';
import moment from 'moment';

import { getPrivateFile, getFileExtension } from 'libs/helpers/helper.lib';

import fileIcon from '../../assets/file-icon.png';

import classes from './style.module.scss';

const FileSingle = ({ barwisFile }) => {
  return (
    <IonItem
      className={classes.ionItem}
      color='dark'
      lines='none'
      key={barwisFile.id}
      button
      detail={false}
      onClick={() => {
        getPrivateFile(barwisFile.path, barwisFile.name);
      }}
    >
      <IonAvatar slot='start'>
        <IonImg src={fileIcon} alt='' />
      </IonAvatar>
      <IonLabel className={classes.ionLabel}>
        <IonText className={classes.barwisFileName}>{barwisFile.name}</IonText>
        <IonText className={classes.barwisFileCreatedAt}>
          {moment(barwisFile.created_at).format('MMMM Do YYYY, h:mm:ss a')} |{' '}
          {getFileExtension(barwisFile.path)}
        </IonText>
      </IonLabel>
    </IonItem>
  );
};

export default FileSingle;
